import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { MixpanelService } from './mixpanel.service';
import { UserPilotService } from './user-pilot.service';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
    // private readonly CONSENT_COOKIE_KEY = '_LexNowConsented';
    // private readonly CONSENT_DURATION_DAYS = 30;

    constructor(
        private cookies: CookieService,
        private mixpanelService: MixpanelService,
        private userPilotService: UserPilotService
    ) {}

    get hasConsented(): boolean {
        // should be restored if we get back opt-out, for now opt-out is disabled
        // return this.cookies.get(this.CONSENT_COOKIE_KEY) === 'true';
        return true;
    }

    // get hasAnswered(): boolean {
    //     return this.cookies.get(this.CONSENT_COOKIE_KEY) !== undefined;
    // }

    applyStoredConsent(): void {
        if (this.hasConsented) {
            this.enableTracking();
        }
    }

    // accept(): void {
    //     this.storeConsent('true');
    //     this.enableTracking();
    // }

    // decline(): void {
    //     this.storeConsent('false');
    //     this.disableTracking();
    // }

    private enableTracking(): void {
        this.mixpanelService.optIn();
        this.userPilotService.enableTracking();
    }

    // private disableTracking(): void {
    //     this.mixpanelService.optOut();
    //     this.userPilotService.disableTracking();
    // }

    // private storeConsent(value: 'true' | 'false'): void {
    //     const expiration = new Date();
    //     expiration.setDate(expiration.getDate() + this.CONSENT_DURATION_DAYS);
    //     this.cookies.put(this.CONSENT_COOKIE_KEY, value, { expires: expiration });
    // }
}
